/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Max_WidthInputs */

const en_tables_rule_sets_max_width = /** @type {(inputs: Tables_Rule_Sets_Max_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Max Width`)
};

const de_tables_rule_sets_max_width = /** @type {(inputs: Tables_Rule_Sets_Max_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Breite`)
};

/**
* | output |
* | --- |
* | "Sets Max Width" |
*
* @param {Tables_Rule_Sets_Max_WidthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_max_width = /** @type {((inputs?: Tables_Rule_Sets_Max_WidthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Max_WidthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_max_width(inputs)
	return de_tables_rule_sets_max_width(inputs)
});